import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from '../grid-container/GridContainer'
import { UiTopBgSlider,UiTopShopBgSlider, UiTopBgSliderLeftContent, UiInnerTopBgSlider, UiTopBgSliderInnerContent } from './UiTopBgSliderElements'

export default function UiInnerBanner(props) {


    return (
        <>
            <UiInnerTopBgSlider>
                <UiTopBgSlider>
                    <UiSingleRow className={props.className}>
                        <UiCol lg="12">
                            <UiTopBgSliderInnerContent>
                                <h2>{props.title}</h2>
                                <p className='sb-top-bg-slider__slider-content-description'>{props.description}</p>
                            </UiTopBgSliderInnerContent>
                        </UiCol>
                    </UiSingleRow>
                </UiTopBgSlider>
            </UiInnerTopBgSlider>
        </>
    )
}
